var angular = require('angular')
var langCs = require('./i18n/cs.js').cs
var langEn = require('./i18n/en.js').en

var uniformsService = require('../../services/uniforms.service')
var logErrorToBackendService = require('aem-libs-angularjs/src/services/log-error-to-backend.service').logErrorToBackendService
require('../wcm-object/wcm-object.component')
require('../ow-input-tel/ow-input-tel.component')
require('../ow-input-checkbox-gdpr/ow-input-checkbox-gdpr.component')
require('../ow-input-text/ow-input-text.component')
require('../ow-input-zip/ow-input-zip.component')
var fieldsCallme = require('../../services/fields-callme')
var uniformsDataservice = require('../../services/uniforms.dataservice')
require('aem-libs-angularjs/src/components/backend-error/backend-error.component.js')
require('aem-libs-angularjs/src/directives/track-element.directive.js')
var isObjectName = require('../../services/isObjectName')
require('./component.css')

angular.module('UniformCallmeCmp', ['TrackElementCmp', 'WcmObjectCmp', 'OwInputTelCmp',
  'OwInputCheckboxGdprCmp', 'BackEndErrorComp', 'OwInputTextCmp', 'OwInputZipCmp'])
  .factory('uniformsService', uniformsService)
  .factory('uniformsDataservice', uniformsDataservice)
  .factory('logErrorToBackendService', logErrorToBackendService)
  .factory('$exceptionHandler', ['$log', 'logErrorToBackendService', function ($log, logErrorToBackendService) {
    return function logErrorToBackendExceptionHandler (exception, cause) {
      $log.error(exception, cause)
      logErrorToBackendService.error(exception, cause)
    }
  }])
  .component('uniformCallme', {
    template: require('./uniform-callme.component.tpl.html'),
    controller: UniformCallmeCtrl,
    controllerAs: 'vm',
    bindings: {
      formId: '<',
      userTrackingParams: '<',
      initValueByBusinessName: '<',
      template: '<'
    }
  })

UniformCallmeCtrl.$inject = ['appLoader', 'i18n', 'uniformsService',
  'uniformsDataservice']

function UniformCallmeCtrl (appLoader, i18n, uniformsService,
  uniformsDataservice) {
  var vm = this

  vm.$onInit = function () {
    i18n.appendLangFile('cs', langCs)
    i18n.appendLangFile('en', langEn)
    vm.error = false
    vm.fields = null
    vm.submit = submit
    vm.isSubmissionPending = false
    vm.isSubmittedSuccessfully = false
    vm.invalidUniform = false
    vm.isObjectName = isObjectName

    getData()
  }

  function submit () {
    if (vm.form.$invalid && !vm.invalidUniform) {
      return
    }
    appLoader.show()
    vm.isSubmissionPending = true
    var fieldsValues = vm.fields.getSubmitFields()
    uniformsDataservice.savePromise(fieldsValues)
      .then(function () {
        vm.isSubmittedSuccessfully = true
        vm.invalidUniform = false
      })
      .catch(function (err) {
        if (err.status === 200 && err.data.status === 'ERR') {
          vm.invalidUniform = true
          vm.fields.setBackendErrorMessages(err.data.messages)
        } else {
          vm.error = true
        }
      })
      .finally(function () {
        vm.isSubmissionPending = false
        appLoader.hide()
      })
  }

  function getData () {
    uniformsDataservice.initPromise(uniformsService, vm.formId)
      .then(function (res) {
        vm.fields = fieldsCallme(res)
        vm.fields.setValuesByDefaultValueI18N(vm.userTrackingParams)
        vm.fields.setValuesByBusinessName(vm.initValueByBusinessName)
        vm.fields.setValuesByURLParameters()
        vm.fields.setValuesToHiddenCookieFields()
        if (vm.fields.leadUrl) {
          vm.fields.leadUrl.value = window.location.href
        }
      })
      .catch(function () {
        vm.error = true
      })
      .finally(appLoader.hide)
  }
}
